export const FETCH_PLAYER_INFO_REQUEST = 'FETCH_PLAYER_INFO_REQUEST'
export const FETCH_PLAYER_INFO_SUCCESS = 'FETCH_PLAYER_INFO_SUCCESS'
export const FETCH_PLAYER_INFO_FAIL = 'FETCH_PLAYER_INFO_FAIL'

export const EDIT_PLAYER_INFO_FAIL = 'EDIT_PLAYER_INFO_FAIL'
export const EDIT_PLAYER_INFO_SUCCESS = 'EDIT_PLAYER_INFO_SUCCESS'
export const EDIT_PLAYER_INFO_REQUEST = 'EDIT_PLAYER_INFO_REQUEST'
export const EDIT_PLAYER_INFO_RESET = 'EDIT_PLAYER_INFO_RESET'
